import type { ShowcaseListProps } from './interfaces';
import styles from './ShowcaseList.module.scss';

const ShowcaseList = ({ children }: ShowcaseListProps) => {
  return <div className={styles.base}>{children}</div>;
};

export default ShowcaseList;
